'use strict';

(function () {
  'use strict';

  angular.module('msUtility').service('mediaQuerySvc', mediaQuerySvc);

  mediaQuerySvc.$inject = ['$window'];

  /* @ngInject */
  function mediaQuerySvc($window) {

    var bp2 = $window.matchMedia('(max-width: 30em)');
    var bp3 = $window.matchMedia('(min-width: 30em) and (max-width: 48em)');
    var bp4 = $window.matchMedia('(min-width: 48em) and (max-width: 62em)');
    var bp5 = $window.matchMedia('(min-width: 62em) and (max-width: 86.375em)');
    var bp6 = $window.matchMedia('(min-width: 86.375em)');

    return {
      bp2: bp2,
      bp3: bp3,
      bp4: bp4,
      bp5: bp5,
      bp6: bp6,
      getGridPageSize: getGridPageSize
    };

    // Request more inspirations on larger screen, and fewer on smaller screens.
    // To keep each row evenly filled,
    // Make sure the page size is a multiple of the number of inspirations in each row.
    // Number in row comes from _community.scss
    function getGridPageSize() {
      switch (true) {
        case bp2.matches:
          return 8;
        case bp3.matches:
          return 12;
        case bp4.matches:
          return 20;
        case bp5.matches:
        case bp6.matches:
          return 24;
        default:
          return 12;
      }
    }
  }
})();